import { NavSectionConfig, MenuVisibilityConfig } from '../../interfaces';

const navigateTo = (path: string) => {
  globalThis.location.href = globalThis.location.origin + path;
};

export const getMenuDropdownItems = (visibilityConfig: MenuVisibilityConfig): NavSectionConfig[] => {
  const { showLWAnalytics, showIndexPage, showLWAIUsage, showUsagePage, showSettingsPage, showSitesPage } = visibilityConfig || {};

  return [
    {
      topLevelLabel: 'Platform',
      cssClass: 'Platform',
      navItems: [
        ...(showLWAnalytics
          ? [
            {
              cssClass: 'signals',
              text: 'Signals',
              path: '/lucidworks-analytics',
              handlePath: () => navigateTo('/lucidworks-analytics'),
            },
          ]
          : []),
        ...(showIndexPage
          ? [
            {
              cssClass: 'indexes',
              text: 'Indexes',
              path: '/fusion',
              handlePath: () => navigateTo('/fusion'),
            },
          ]
          : []),
        ...(showLWAIUsage
          ? [
            {
              cssClass: 'models',
              text: 'Models',
              path: '/lucidworks-ai',
              handlePath: () => navigateTo('/lucidworks-ai'),
            },
          ]
          : []),
      ],
    },
    ...(showSitesPage
      ? [
        {
          topLevelLabel: 'Sites',
          cssClass: 'sites',
          navItems: [],
        },
      ]
      : []),
    {
      topLevelLabel: 'Account',
      cssClass: 'account',
      navItems: [
        ...(showUsagePage
          ? [
            {
              cssClass: 'usage',
              text: 'Usage',
              path: '/usage',
              handlePath: () => navigateTo('/usage'),
            },
          ]
          : []),
        ...(showSettingsPage
          ? [
            {
              cssClass: 'settings',
              text: 'Settings',
              path: '/settings',
              handlePath: () => navigateTo('/settings'),
            },
          ]
          : []),
      ],
    },
  ];
};
